const LOGLEVEL_DEBUG = -1;
const LOGLEVEL_LOG = 0;
const LOGLEVEL_INFO = 1;
const LOGLEVEL_WARN = 2;
const LOGLEVEL_ERROR = 3;
const MAX_LOG_LENGTH = 1000;

var globalLevel = 99; //默认不打印log

init();
function init() {
    try {
        const logLev = Number(localStorage._logLevel);
        if (!isNaN(logLev)) {
            globalLevel = logLev;
        } 
    } catch (error) {
        console.log(error);
    }

}

function padNum(val, digit) {
    let len = val.toString().length;
    let cnt = Math.max(0, digit - len);
    return '0'.repeat(cnt) + val;
}

function getLogTime() {
    var date = new Date();
    var yy = date.getFullYear();
    var mm = padNum(date.getMonth() + 1, 2);
    var dd = padNum(date.getDate(), 2);
    var h = padNum(date.getHours(), 2);
    var m = padNum(date.getMinutes(), 2);
    var s = padNum(date.getSeconds(), 2);
    var ms = padNum(date.getMilliseconds(), 3);
    return `${yy}-${mm}-${dd} ${h}:${m}:${s}.${ms} `;
}

let logger = {
    _data: [],
    _length: 0,
    init,

    debug: function() {
        var logTime = getLogTime();
        var args = Array.prototype.slice.call(arguments);
        args[0] = logTime + args[0];
        if (globalLevel <= LOGLEVEL_DEBUG) {
            //some browser(version) unsupport debug
            //console.debug.apply(console, args);
            console.log.apply(console, args);
        }
    },

    log: function(s) {
        var logTime = getLogTime();
        var args = Array.prototype.slice.call(arguments);
        args[0] = logTime + args[0];
        if (globalLevel <= LOGLEVEL_LOG) {
            console.log.apply(console, args);
        }
        logger.record(args, 'log');
    },

    info: function(s) {
        var logTime = getLogTime();
        var args = Array.prototype.slice.call(arguments);
        args[0] = logTime + args[0];
        if (globalLevel <= LOGLEVEL_INFO) {
            console.info.apply(console, args);
        }
        logger.record(args, 'info');
    },

    warn: function(s) {
        var logTime = getLogTime();
        var args = Array.prototype.slice.call(arguments);
        args[0] = logTime + args[0];
        if (globalLevel <= LOGLEVEL_WARN) {
            console.warn.apply(console, args);
        }
        logger.record(args, 'warn');
    },

    error: function(s) {
        var logTime = getLogTime();
        var args = Array.prototype.slice.call(arguments);
        args[0] = logTime + args[0];
        if (globalLevel <= LOGLEVEL_ERROR) {
            console.error.apply(console, args);
        }
        logger.record(args, 'error');
    },

    group: function(s) {
        var logTime = getLogTime();
        var args = Array.prototype.slice.call(arguments);
        args[0] = logTime + args[0];
        if (globalLevel <= LOGLEVEL_INFO) {
            var logFunc = console.groupCollapsed || console.group || console.log;
            logFunc.apply(console, args);
        }
        logger.record(args, 'group');
    },

    groupEnd: function() {
        if (console.groupEnd) {
            console.groupEnd.apply(console);
        }
    },

    setLevel: function(newLevel) {
        if (newLevel != globalLevel) {
            console.log(getLogTime() + ' set log level from ' + globalLevel + ' to ' + newLevel);
            globalLevel = newLevel;
        }
    },

    getLevel: function() {
        return globalLevel;
    },

    record: function(args, type) {
        if (logger._length === MAX_LOG_LENGTH + 100) {
            logger._data.splice(0, 100);
            logger._length = MAX_LOG_LENGTH;
        }
        var n = 0;
        var s = (args.shift() || '').toString();
        s = s.replace(/\%c/ig, function(match, $1) {
            n++;
            return '';
        });
        while (n-- && args.length) {
            args.shift();
        }
        for (var i = 0, len = args.length; i < len; i++) {
            var ss = args[i];
            if (typeof(ss) == 'object') {
                // args[i] = JSON.stringify(args[i]);
                args[i] = '';
            }
        }
        args.unshift(s);
        var msg = args.join(' ');
        logger._length++;
        logger._data.push(`[${type}]${msg}`);
    },

    getLog: function() {
        return logger._data;
    },

    logcss: (color) => {
        return "color:" + color + ";font-weight:900";
    }

};

export default logger;